export default __webpack_public_path__ + "static/media/Flag_of_Bolivia.1dee478c.svg";